export type CampaignTypesValues = {
	type: string
	value: string
	label: string
}

export const CAMPAIGN_TYPES_VALUES = [
	// { isAgent: false, value: 'Motivated Seller', label: 'Motivated Seller' },
	// { isAgent: false, value: 'Multifamily', label: 'Multifamily' }, // not sure which of these need to stay
	// { isAgent: false, value: 'Preforeclosure', label: 'Preforeclosure' },
	// { isAgent: false, value: 'Expired Listing', label: 'Expired Listing' },
	// { isAgent: false, value: 'High Equity', label: 'High Equity' },
	// { isAgent: false, value: 'Agent Buyer', label: 'Agent Buyer' },
	// { isAgent: false, value: 'The Caroline Cain', label: 'The Caroline Cain' },
	// { isAgent: false, value: 'The Soft Set', label: 'The Soft Set' },
	// { isAgent: false, value: 'Direct to Agent', label: 'Direct to Agent' },
]
